
<template>
  <div class="detail_box">
    <div class="loan">
      <p class="com_title"><span class="com_line"></span>会员协议</p>
      <div class="p_con">
        请认真阅读并理解以下内容，其中以加粗方式显著标识的文字，请着重阅读、慎重考虑。<br>
        本协议是您与77信用（简称"本站"）所有者（以下简称为"平台"）之间就77VIP所订立的契约。请仔细阅读以下的全部条款, 特别是免除或者限制责任的条款, 管辖与法律适用条款。(限制、 免责条款可能以黑体加粗或加下划线的形式提示您重点注意。)一经点击“同意”或“勾选”后完成下一步操作,即视为您同意了本协议全部条款。所以,若您对本协议任何条款有异议的, 请不要操作下一步或点击同意”或“勾选"。<br>
        <p class="title">第1条 相关定义</p>
        1.177VIP：77VIP是为77信用客户打造的高级会员服务。<br>
        <p class="title">第2条 本站服务条款的确认和接纳</p>
        2.1本站所提供的77VIP相关所有权和运作权归77信用所有<br>
        2.2用户点击同意本协议的，即视为用户确认自己同意接受77VIP相关服务的条款，且同意按本协议内容履行，如产生用户相关责任的，同意承担相应法律责任。<br>
        2.3如果您在18周岁以下，您只能在父母或监护人的监护参与下方能参与体验该服务。<br>
        2.477信用保留在中华人民共和国大陆地区法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容等相关权利。<br>
        2.5您同意并理解，如您的77VIP会员资格到期，77信用将中止为您提供VIP相关权益。如您不希望购买77VIP正式资格，或者您已具有77VIP正式资格但不想对77VIP资格续期，或者您不希望自动扣款，则您应及时联系77信用客服，77信用在您变更77VIP签约方式之前已经收取的会员会费不受影响。<br>
        2.6 77VIP开通后1小时内，您希望在已开通的服务期内中途主动取消服务或终止资格的，联系77信用客服处理，并说明原因，平台将全额退款，否则平台不支持退款。<br>
        <p class="title">第3条 会员权益</p>
        3.1您成为77信用正式会员后，可享受的权益以77信用APP公布的信息为准。为更好的向会员提供服务，77信用有权基于自身业务发展需要调整全部或部分会员权益。77信用就前述权益调整将在相应服务页面进行通知或公告，您可以通过77信用客服咨询最新的会员权益内容。<br>
        3.2拒就赔权益特别说明：在77VIP（VIP光速/加速套餐）有效期内，VIP用户申请平台指定机构的贷款（凡是带有“拒就赔”标识的贷款机构）被拒后，则可使用“拒就赔现金券”，单次只能使用一张，不能叠加使用。<br>
        3.377VIP权益中的现金券或红包单次只能使用一张，不支持叠加使用。<br>
        3.4同一用户，是指联系方式、IP地址等与用户身份相关的信息，其中任意一项或数项存在相同、相似、通过特殊标记行程批量信息、或其他非真实有效等情形的，均将被认定为同一用户，按权益规则中的同一用户处理；<br>
        <p class="title">第4条 用户会员使用注意事项</p>
        4.1提交申请开通时，用户同意并提交本人手机号码和邮箱等本站需要的个人资料，并保证您提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新您的注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽，用户需承担因此引起的相应责任及后果，并且77信用保留终止用户参与该活动的权利。<br>
        4.2服务开通后，用户应谨慎合理的保存、使用您的用户名和密码，不得将在本站注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，同时77信用在该种情况下有权做出独立判断，可采取暂停或关闭用户参与资格等措施。<br>
        4.3用户同意，77信用拥有通过邮件、短信电话等形式，向您发送相关活动信息等必要信息的权利。如您不愿意接收前述信息，可申请退订该项服务。<br>
        4.4用户同意，您应合理使用您享有的会员权益，除为实现用户自身的会员利益外，不得利用您享有的权益非法获利，不得以任何形式售卖您所享有的权益，不得滥用您所享有的权益，如因用户不当行为致77信用合理怀疑的或判定的，77信用有权暂停或关闭用户该活动的权益，此外，用户需承担因此引起的相应责任及后果。<br>
        <p class="title">第5条 协议更新及用户关注义务</p>
        5.1根据国家法律法规变化及网站运营需要，77信用有权以网站公告的方式进行不定期地制定、修改本协议及/或相关服务规则，暂停、取消和修改本协议条款，修改后的协议一旦被公告在本站上即生效，并代替原来的协议。用户应及时关注不时发布的各项服务规则及本协议的变更。若不同意相关规则及条款修改的，应及时终止与本站的协议。如用户继续使用本网站提供的服务的，即视为同意更新后的协议。77信用建议您在使用本站之前阅读本协议及本站的公告。<br>
        <p class="title">第6条 法律管辖和适用</p>
        6.1本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。 如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向金华市金东区人民法院提起诉讼。<br>
        <p class="title">第7条 其他</p>
        7.177信用网站所有者是指在政府部门依法许可或备案的77信用网站经营主体。<br>
        7.2如因不可抗力或其它本站无法控制的原因使本站活动服务无法及时提供或无法按本协议进行的，77信用会合理地尽力协助处理善后事宜。<br>
        7.3用户除遵守该用户协议外，仍应同时遵守《77信用平台注册协议》与《隐私保护政策》。<br>
        7.4本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请用户着重阅读。<br>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  components: {
    // Head,
  },
  data () {
    return {
    }
  },
  mounted () {
    this.productId = this.$route.query.productId;
    this.util.title('会员服务协议');
  },

  methods: {

  }
}
</script>
<style scoped>
.detail_box {
  background: #fff;
  padding: 0.2rem 0.15rem;
}
.com_title {
  font-size: 0.2rem;
  color: #666;
  font-weight: bold;
  border-bottom: 1px solid #efefef;
  padding-bottom: 0.1rem;
  margin-bottom: 0.1rem;
}
.p_con {
  font-size: 0.14rem;
  line-height: 0.25rem;
}
.title {
  margin: 0;
  padding: 0;
  font-size: 0.16rem;
  padding: 0.04rem 0;
}
</style>
